import { render, staticRenderFns } from "./demand-module2.vue?vue&type=template&id=12b33dca&scoped=true"
import script from "./demand-module2.vue?vue&type=script&lang=js"
export * from "./demand-module2.vue?vue&type=script&lang=js"
import style0 from "./demand-module2.vue?vue&type=style&index=0&id=12b33dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b33dca",
  null
  
)

export default component.exports